import {
  ResizablePanel,
} from "@/components/ui/resizable";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CommentsListCard } from "./CommentsListCard";
import { AttachmentsPanel } from "./AttachmentsPanel";
import { FileAttachment } from "@/types/attachment";

interface TextSelection {
  start: number;
  end: number;
  text: string;
  originalText: string;
}

interface Comment {
  id: string;
  text: string;
  color: string;
  number: number;
  textSelections: TextSelection[];
  isGeneral: boolean;
}

interface AnnotationsPanelProps {
  // Comments
  comments: Comment[];
  onAddComment: (text: string) => void;
  onDeleteComment: (commentId: string) => void;
  onEditComment: (commentId: string, newText: string) => void;
  selectedText: string;
  highlightedCommentId: string | null;
  isComposingComment: boolean;
  setIsComposingComment: (isComposing: boolean) => void;
  onCommentClick?: (commentId: string) => void;

  // Attachments
  attachments: FileAttachment[];
  onAddAttachment: (files: File[]) => void;
  onDeleteAttachment: (attachmentId: string) => void;
  onHighlightAttachment: (attachmentId: string | null) => void;
  highlightedAttachmentId: string | null;
  onAttachmentClick?: (attachmentId: string) => void;
}

export const AnnotationsPanel = ({
  comments,
  onAddComment,
  onDeleteComment,
  onEditComment,
  selectedText,
  highlightedCommentId,
  isComposingComment,
  setIsComposingComment,
  onCommentClick,
  attachments,
  onAddAttachment,
  onDeleteAttachment,
  onHighlightAttachment,
  highlightedAttachmentId,
  onAttachmentClick,
}: AnnotationsPanelProps) => {
  return (
    <ResizablePanel defaultSize={30} minSize={20} maxSize={50}>
      <Tabs defaultValue="comments" className="h-full flex flex-col">
        <TabsList className="w-full rounded-none border-b">
          <TabsTrigger value="comments" className="flex-1">
            Comments
          </TabsTrigger>
          <TabsTrigger value="attachments" className="flex-1">
            Attachments
          </TabsTrigger>
        </TabsList>

        <TabsContent value="comments" className="flex-1 min-h-0 m-0 h-0" forceMount>
          <CommentsListCard
            comments={comments}
            onAddComment={onAddComment}
            onDeleteComment={onDeleteComment}
            onEditComment={onEditComment}
            onAddAttachment={onAddAttachment}
            selectedText={selectedText}
            highlightedCommentId={highlightedCommentId}
            isComposingComment={isComposingComment}
            setIsComposingComment={setIsComposingComment}
          />
        </TabsContent>

        <TabsContent value="attachments" className="flex-1 min-h-0 m-0 h-0" forceMount>
          <AttachmentsPanel
            attachments={attachments}
            onDeleteAttachment={onDeleteAttachment}
            onAddAttachment={onAddAttachment}
            onHighlightAttachment={onHighlightAttachment}
            highlightedAttachmentId={highlightedAttachmentId}
          />
        </TabsContent>
      </Tabs>
    </ResizablePanel>
  );
};
